// extracted by mini-css-extract-plugin
module.exports = {"radiotext":"custradio_radiotext__v2QqC"};